/**
 * CT Product Bundles — wishlist (shared key with shop / PDP)
 */
(() => {
  const STORAGE_KEY = 'ct-wishlist-handles';

  /** @returns {Set<string>} */
  const readWishlist = () => {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      const list = raw ? JSON.parse(raw) : [];
      return new Set(Array.isArray(list) ? list.map(String) : []);
    } catch {
      return new Set();
    }
  };

  /** @param {Set<string>} set */
  const writeWishlist = (set) => {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify([...set]));
    } catch {
      /* private mode */
    }
  };

  /**
   * @param {HTMLElement} root
   * @param {Set<string>} set
   */
  const syncWish = (root, set) => {
    root.querySelectorAll('[data-ct-pb-wishlist]').forEach((btn) => {
      if (!(btn instanceof HTMLButtonElement)) return;
      const handle = btn.dataset.productHandle || '';
      const on = handle !== '' && set.has(handle);
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      btn.classList.toggle('is-active', on);
    });
  };

  /**
   * @param {HTMLElement} root
   */
  const init = (root) => {
    if (!(root instanceof HTMLElement) || root.dataset.ctPbReady === '1') return;
    root.dataset.ctPbReady = '1';

    const wishlist = readWishlist();
    syncWish(root, wishlist);

    root.addEventListener('click', (event) => {
      const target = event.target;
      if (!(target instanceof Element)) return;
      const btn = target.closest('[data-ct-pb-wishlist]');
      if (!(btn instanceof HTMLButtonElement) || !root.contains(btn)) return;

      event.preventDefault();
      event.stopPropagation();

      const handle = btn.dataset.productHandle || '';
      if (!handle) return;

      if (wishlist.has(handle)) wishlist.delete(handle);
      else wishlist.add(handle);

      writeWishlist(wishlist);
      syncWish(root, wishlist);
      btn.dispatchEvent(
        new CustomEvent('ct:wishlist-change', {
          bubbles: true,
          detail: { handle, active: wishlist.has(handle) },
        })
      );
    });
  };

  const boot = () => {
    document.querySelectorAll('[data-ct-pb]').forEach((root) => {
      if (root instanceof HTMLElement) init(root);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', (event) => {
    const section = event.target;
    if (!(section instanceof HTMLElement)) return;
    const root = section.matches('[data-ct-pb]') ? section : section.querySelector('[data-ct-pb]');
    if (root instanceof HTMLElement) {
      delete root.dataset.ctPbReady;
      init(root);
    }
  });
})();
